/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chatemptyprompt2Inputs */

const en_chatemptyprompt2 = /** @type {(inputs: Chatemptyprompt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell me what happened. For example:`)
};

const pt_chatemptyprompt2 = /** @type {(inputs: Chatemptyprompt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta-me o que aconteceu. Por exemplo:`)
};

/**
* | output |
* | --- |
* | "Tell me what happened. For example:" |
*
* @param {Chatemptyprompt2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const chatemptyprompt2 = /** @type {((inputs?: Chatemptyprompt2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatemptyprompt2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chatemptyprompt2(inputs)
	return pt_chatemptyprompt2(inputs)
});
export { chatemptyprompt2 as "chatEmptyPrompt" }